import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse,HttpHeaders, HttpParams  } from '@angular/common/http';
import { catchError, Observable, of, throwError  } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http:HttpClient) { }

  loginUser(username: any, password: any): Observable<any> {
    const url = environment.url + "login";
    const body = {
      UserName: username,
      Password: password
    };
    const headers = new HttpHeaders();
    return this.http.post(url, body, { headers: headers });
  }

  logoutUser():Observable<any>{
    const url = environment.url + "logout";
    const authenticationKey:any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders().set('X-Security-AuthKey', authenticationKey);
    return this.http.put(url,{}, { headers: headers });
  }

  registerUser(formData:any): Observable<any> {
    const url = environment.url + "register"
    console.log("Form Data is:", formData);
    debugger;
    const body = {
      FirstName: formData.firstName,
      LastName: formData.lastName,
      UserName: formData.username,
      Accent: formData.accent,
      Gender: formData.gender,
      Age: formData.age,
      Password: formData.password
    };
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(url, body, { headers: headers });
  }


  modelInference(formData:any): Observable<any> {
    const url = environment.url + "generate_audio_by_text"
    console.log("Form Data is:", formData);
    // debugger;
    const params = {
      message: formData.message,
      lang: formData.lang,
      model_name: formData.model_name
    };
    
  
    const headers = new HttpHeaders()
      .set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5')
      .set('Content-Type', 'application/json');
  
    return this.http.get(url, { headers: headers, params: params });
  }

  generateSystemAudio(formData:any,page:number): Observable<any> {
    const url = environment.url + "generate_call_system_audio";
    console.log("Form Data is:", formData);
    // debugger;

    const params: any = {
      // message: formData.message,
      lang: formData.lang,
      model_name: formData.model_name,
      page: page,
      filter: formData.filter_value,
      usability:formData.filter_usability_value,
      verified:formData.filter_verified_value,
    };

    if (formData.text_type === 'mozilla_text') {
      params.type = formData.text_type;
    }

    if (formData.searchQuery) {
      params.search = formData.searchQuery;
    }

  
    const headers = new HttpHeaders()
      .set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5')
      .set('Content-Type', 'application/json');

    
  
    return this.http.get(url, { headers: headers, params: params });
  }

  searchText(searchText:string,page:Number,fromMyHistoryPage:boolean): Observable<any> {
    page = page ? page: 1;

    let url_for_search: string;
    if(fromMyHistoryPage){
      const filter_user = localStorage.getItem('userId');
      url_for_search = environment.url + "getData" + '?text=' + searchText + (filter_user === '1' ? '&page=' + page : '&clientId=' + filter_user + '&page=' + page);
    }else{

      const filter_user = localStorage.getItem('selectedOptionUser');
      url_for_search = environment.url + "getData" + '?text=' + searchText + (filter_user === '1' ? '&page=' + page : '&clientId=' + filter_user + '&page=' + page);
    }



    const headers = new HttpHeaders()
      .set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5')
      .set('Content-Type', 'application/json');
  
    return this.http.get(url_for_search, { headers: headers});
  }

  filterTextDatewise(searchText:string,page:Number,fromMyHistoryPage:boolean,startDate:any,endDate:any): Observable<any> {

    let url_for_filter:string;
    if(localStorage.getItem('selectedOptionUser') === '1' && !fromMyHistoryPage){
      url_for_filter = environment.url + "getData" + '?startDate=' + startDate + '&endDate=' + endDate +  '&page=' + page;
    }
    
    else if(!fromMyHistoryPage){
      const selected_user = localStorage.getItem('selectedOptionUser');
      if(selected_user){
        url_for_filter = environment.url + "getData" + '?startDate=' + startDate + '&endDate=' + endDate + '&clientId=' + selected_user + '&page=' + page;
      }else{
        url_for_filter = environment.url + "getData" + '?startDate=' + startDate + '&endDate=' + endDate +  '&page=' + page;
      }
        
    }
    else if(fromMyHistoryPage){
      const filter_user = localStorage.getItem('userId');
      url_for_filter = environment.url + "getData" + '?startDate=' + startDate + '&endDate=' + endDate + '&clientId=' + filter_user + '&page=' + page;
    }else{
      const selected_user = localStorage.getItem('selectedOptionUser');
      url_for_filter = environment.url + "getData" + '?startDate=' + startDate + '&endDate=' + endDate + '&clientId=' + selected_user + '&page=' + page;
    }

    const headers = new HttpHeaders()
      .set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5')
      .set('Content-Type', 'application/json');
  
    return this.http.get(url_for_filter, { headers: headers});
  }

  retriveText(lang:any,cate:any,textcount: string = ''): Observable<any>{
    const clientId = localStorage.getItem('userId');
    // console.log("CCCCCCCCCCCCClient Id is:",clientId)
    let url = environment.url + "retriveText" + '?language=' + lang +'&clientId=' + clientId;
    // Only modify the URL if 'cate' is not 'null' and not 'all'
    if (cate !== null && cate !== 'all') {
      url += '&type=' + cate;
    }
    if (textcount !== '' && textcount !== 'all'){
      url += "&textcount=" + textcount;
    }

    // console.log("full url is:",url)
    const authenticationKey:any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders().set('X-Security-AuthKey', authenticationKey);
    // return this.http.get(url, { headers: headers });
    return this.http.get(url, { headers: headers }).pipe(
      // Handle errors
      catchError((error: HttpErrorResponse) => {
        console.error('Error occurred:', error.message);
        // Return a fallback value or an empty observable
        return of(null);
      })
    );
  }

  retriveTextList(lang:any,cate:any,textcount: string = '',totaltextcount: string = '',current_page:any,page_size:any,searchQuery:any): Observable<any>{
    const clientId = localStorage.getItem('userId');
    // console.log("CCCCCCCCCCCCClient Id is:",clientId)
    let url = environment.url + "retriveText" + '?language=' + lang +'&clientId=' + clientId;
    // Only modify the URL if 'cate' is not 'null' and not 'all'
    if (cate !== null && cate !== 'all') {
      url += '&type=' + cate;
    }
    if (textcount !== '' && textcount !== 'all'){
      url += "&textcount=" + textcount;
    }
    if (totaltextcount !== '' && totaltextcount !== 'all'){
      url += "&totaltextcount=" + totaltextcount;
    }

    url += `&page=${current_page}&pagesize=${page_size}`;

    // Append searchQuery only if it's provided
    if (searchQuery && searchQuery.trim() !== '') {
      url += `&search=${encodeURIComponent(searchQuery)}`;
    }

    



    // console.log("full url is:",url)
    const authenticationKey:any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders().set('X-Security-AuthKey', authenticationKey);
    // return this.http.get(url, { headers: headers });
    return this.http.get(url, { headers: headers }).pipe(
      // Handle errors
      catchError((error: HttpErrorResponse) => {
        console.error('Error occurred:', error.message);
        // Return a fallback value or an empty observable
        return of(null);
      })
    );
  }





  addText(formData:any,UrlID: string | null = null): Observable<any>{
    let url = environment.url + "addText";
    const authenticationKey:any = localStorage.getItem('authenticationKey');
    // const headers = new HttpHeaders().set('X-Security-AuthKey', authenticationKey);
    const headers = new HttpHeaders({
      'X-Security-Authkey': authenticationKey,
      'Content-Type': 'application/json'
    });
    // const params = {
    //   message: formData.message,
    //   lang: formData.lang,
    // };

    const params = {
      Text: formData.message,
      Language: formData.lang,
      Type: formData.type,
      SequenceFlag:true,
      Url: UrlID
      // Url: 'https://datacreationtool.procit.com/nodeapi_inferencing/audio/tts_en_1.0.0_rc1/good_afternoon_my_name_is_annie_the_digital_assistant_in_order_to_help_you_quickly_and_efficiently_i_will_ask_you_to_answer_a_few_questions_this_way_my_colleagues_can_offer_you_better_support_do_you_want_to_answer_my_questions.wav'
    };

    return this.http.post(url, params, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error occurred:', error.message);
        return of(null); // Return a fallback value or empty observable
      })
    );
  }


 updateText(textId: string, body:any): Observable<any> {
    const url = environment.url + "UpdateText/" + textId;
    const authenticationKey: any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders({
      'X-Security-Authkey': authenticationKey,
      'Content-Type': 'application/json'
    });
    return this.http.put(url, body, { headers: headers });
  }

  deleteText(textId: string): Observable<any> {
    const url = environment.url + "removeText/" + textId;
    const authenticationKey: any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders({
      'X-Security-Authkey': authenticationKey,
      'Content-Type': 'application/json'
    });
    return this.http.delete(url, { headers: headers });
  }

  removeRecordedWord(urlId:string,recorded_text:any){
      console.log("api call to delete recorded text",urlId);
      if(urlId){
        urlId = urlId.split('/audio/')[1];
      }

      const data = {
        "recorded_text": recorded_text
      }

      const url = environment.url + 'remove_recorded_words/' + urlId;
      const headers = new HttpHeaders().set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5').set('Content-Type', 'application/json');

      return this.http.put<any>(url, data, { headers }).pipe(
        catchError((error) => {
          console.error('Error occurred during removeRecordedWord:', error.message);
          // Return a fallback value or an empty observable
          return of(null);
        })
      );
    }

  
  
  
  
  removeUrl(idOfTextFromServer: string): Observable<any> {
    const url = environment.url + "removeUrl/" + idOfTextFromServer;
    const authenticationKey: any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders({
      'X-Security-Authkey': authenticationKey,
      'Content-Type': 'application/json'
    });
    return this.http.put(url, {}, { headers: headers });
  }
  

  

  getModelList(lang:any): Observable<any>{

    let url = environment.url + "list_models" + '?lang=' + lang ;
   
    const headers = new HttpHeaders({
      'X-Security-Authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5',
      'Content-Type': 'application/json'
    });
    return this.http.get(url, { headers: headers });
  }

  // Function to fetch saved data
  retriveSavedData(lang:any,cate:any,clientId:any,page:any,passClientId:boolean): Observable<any> {
    let url = environment.url + "getData"
    if(passClientId){
      url = url + '?clientId=' + clientId + '&page=' + page;
    }else{
      url = url + '?page=' + page;
    }
    
    // Set headers
    const headers = new HttpHeaders().set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5').set('Content-Type', 'application/json');
    
    // Make the GET request
    return this.http.get<any>(url, { headers, observe: 'response' }).pipe(
      catchError((error) => {
        console.error('Error occurred during savedDataApiCall:', error.message);
        // Return a fallback value or an empty observable
        return of(null);
      })
    );
  }



 


  //update usable data
  updateUsableValue(AudiopathId:any,ClientId:any,Usable:any): Observable<any> {

    let url = environment.url + "updateAudioUsable" + '?ClientId=' + ClientId + '&AudiopathId=' + AudiopathId + '&Usable=' + Usable;
    
    
    // Set headers
    const headers = new HttpHeaders().set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5').set('Content-Type', 'application/json');
    
    // Make the GET request
    return this.http.put<any>(url, null, { headers }).pipe(
      catchError((error) => {
        console.error('Error occurred during savedDataApiCall:', error.message);
        // Return a fallback value or an empty observable
        return of(null);
      })
    );
  }


  updateInterpretationValue(AudiopathId:any,ClientId:any,intepretationOnly:any): Observable<any> {

    let url = environment.url + "updateAudioInterpretation" + '?ClientId=' + ClientId + '&AudiopathId=' + AudiopathId + '&IsForInterpretation=' + intepretationOnly;
    
    
    // Set headers
    const headers = new HttpHeaders().set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5').set('Content-Type', 'application/json');
    
    // Make the GET request
    return this.http.put<any>(url, null, { headers }).pipe(
      catchError((error) => {
        console.error('Error occurred during savedDataApiCall:', error.message);
        // Return a fallback value or an empty observable
        return of(null);
      })
    );
  }

  addAudio(audioBlob: Blob, textId: string,textdateModified:any): Observable<any>{

    const url = environment.url + "addAudiopath";
    const authenticationKey:any = localStorage.getItem('authenticationKey');

    const formData = new FormData();
    formData.append('AudioFile', audioBlob, 'apple.mp3');
    formData.append('Textid', textId);
    formData.append('Usable','true');
    
    console.log("MMMMMMMMMMMModified date for text:",textdateModified)
    if (textdateModified !== null){
      formData.append("TextModifiedDate",textdateModified);
    }
    // DateModified:"2025-02-25 10:21:04"
    const headers = new HttpHeaders().set('X-Security-AuthKey', authenticationKey);
    return this.http.post(url, formData, { headers:headers });


  }

  addTextWithAudio(formData: FormData): Observable<any> {
    const url = environment.url + "addTextWithAudioFile";
    const authenticationKey:any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders().set('X-Security-AuthKey', authenticationKey);

    return this.http.post(url, formData, { headers:headers });
  }

  getUser(): Observable<any>{
    // const clientId = localStorage.getItem('userId');
    let url = environment.url + "/getUsers";
    const headers = new HttpHeaders().set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5');
    return this.http.get(url, { headers: headers }).pipe(
      // Handle errors
      catchError((error: HttpErrorResponse) => {
        console.error('Error occurred:', error.message);
        // Return a fallback value or an empty observable
        return of(null);
      })
    );
  }


  

  updateMetaDataForModelInferencingData(filename: string,current_model_name:string, url: string,intonation:boolean, usability: boolean,text_to_update:string,mispronounced_words:string,not_recorded_mispronounced_words:string,verified:boolean): Observable<any> {
    const apiUrl = `${environment.url}update_metadata/${current_model_name}/${filename}`;
    
    const headers = new HttpHeaders()
      .set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5')
      .set('Content-Type', 'application/json');

    
    // mispronounced_words = " ";
    // not_recorded_mispronounced_words = " ";
    
    const body = {
      remarks: text_to_update,
      usability: usability,
      intonation: intonation,
      mispronounced_words:mispronounced_words,
      not_recorded_mispronounced_words:not_recorded_mispronounced_words,
      verified_by:verified ? localStorage.getItem('userName') : ' ',
      verified:verified

    };

    return this.http.put(apiUrl, body, { headers });
  }


  getModelInferencingHistory(text:string): Observable<any> {
    const lang = localStorage.getItem('selectedModelLanguageForTTS');
    // const text = 'mag ik uw gegevens noteren'
    const url = environment.url + "history" + '?lang=' + lang + '&text=' + text;
    
    const headers = new HttpHeaders()
      .set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5')
      .set('Content-Type', 'application/json');


    return this.http.get(url, { headers: headers});
  }


  getAudioTextHistory(id: string,showDataOf:string): Observable<any> {
    const user_id = localStorage.getItem('userId');
    const url = showDataOf === 'current_user'
      ? `https://datacreationtool.procit.com/nodeapi/getAudioTextHistory/${id}?clientId=${user_id}`
      : `https://datacreationtool.procit.com/nodeapi/getAudioTextHistory/${id}`;

    const authenticationKey:any = localStorage.getItem('authenticationKey');
  
    const headers = new HttpHeaders()
      .set('x-security-authkey', authenticationKey)
      .set('Accept', 'application/json, text/plain, */*');
  
    return this.http.get(url, { headers });
  }

  deleteAudioFile(id: string): Observable<any> {
    const url = `https://datacreationtool.procit.com/nodeapi/removeAudioText/${id}`;
    const authenticationKey:any = localStorage.getItem('authenticationKey');
  
    const headers = new HttpHeaders()
      .set('x-security-authkey', authenticationKey)
      .set('Accept', 'application/json, text/plain, */*');
  
    return this.http.delete(url, { headers });
  }


  // Api's for sentiment analysis

  retriveSentimentData(lang:any,current_page:any,page_size:any): Observable<any>{
    let url = environment.url + "flag-prediction" + '?lang=' + lang +'&page=' + current_page;
    const headers = new HttpHeaders()
      .set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5')
      .set('Content-Type', 'application/json');
    return this.http.get(url, { headers: headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error occurred:', error.message);
        return of(null);
      })
    );
  }


  sentimentmodelInference(formData: any): Observable<any> {
    const url = environment.url + "analyze";  // e.g. https://datacreationtool.procit.com/nodeapi/analyze
  
    const params = new HttpParams()
      .set('lang', formData.lang)
      .set('text', formData.message);
  
    const headers = new HttpHeaders()
      .set('x-security-authkey', 'c14475f1-4968-4418-bb23-f242cf8070c5');
  
    return this.http.post(url, null, { headers, params });
  }

  // sentimentmodelAddData(formData: any): Observable<any> {
  //   const url = environment.url + "flag-prediction";  // e.g. https://datacreationtool.procit.com/nodeapi/analyze
  //   const userId = localStorage.getItem('userId') || '';
  //   const params = new HttpParams()
  //     .set('input_text', formData.message)
  //     .set('predicted_sentiment', formData.predicted_sentiment)
  //     .set('confidence_score', formData.confidence_score)
  //     .set('flag_status', formData.flag_status)
  //     .set('flag_reason', formData.sentiment)
  //     .set('user_id', userId)
  //     .set('lang', formData.language);
  
  //   const headers = new HttpHeaders()
  //     .set('x-security-authkey', 'c14475f1-4968-4418-bb23-f242cf8070c5');
  
  //   return this.http.post(url, null, { headers, params });
  // }

  sentimentmodelAddData(formData: any): Observable<any> {
    const url = environment.url + "flag-prediction";  // e.g. https://datacreationtool.procit.com/nodeapi/flag-prediction
    const userId = localStorage.getItem('userId') || '';
  
    const body = {
      input_text: formData.message,
      predicted_sentiment: formData.predicted_sentiment,
      confidence_score: formData.confidence_score,
      flag_status: formData.flag_status,
      flag_reason: formData.sentiment,
      user_id: userId,
      language: formData.language
    };
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });
  
    return this.http.post(url, body, { headers });
  }



  // getSTTInferenceSavedData(lang:string,current_page:any,page_size:any,user:any,text:any): Observable<any> {
  //   const url = environment.url + "stt_sound_inference"; 
  //   const params = new HttpParams()
  //   .set('language', lang)
  //   .set('page', current_page)
  //   .set('page_size', page_size)
  //   .set('original_text', text)
  //   .set('user_id', user === '1' ? '' : user);

  //   const headers = new HttpHeaders({
  //     'accept': 'application/json',
  //     'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
  //   });

  //   return this.http.get(url, { headers, params });
  // }


  getSTTInferenceAllSavedData(lang:string,current_page:any,page_size:any,user:any,text:any): Observable<any> {
    const url = environment.url + "stt_sound_inference"; 

    const user_id = (user === 'all_user') ? '' : (user || localStorage.getItem('userId'));
    console.log("UUUUUser for STT inference data:", user);

    const params = new HttpParams()
    .set('language', lang)
    .set('page', current_page)
    .set('page_size', page_size)
    .set('user_id', user_id)
    .set('text_id', text);

    const headers = new HttpHeaders({
      'accept': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.get(url, { headers, params });
  }

  getSTTInferenceSavedData(lang:string,current_page:any,page_size:any,user:any,text:any,current_user_id:any,): Observable<any> {
    const url = environment.url + "stt_sound_inference"; 
    
    const user_id: string = (user === 'current_user') ? current_user_id : '';
    console.log("UUUUUser for STT inference data:", user);

    const params = new HttpParams()
    .set('language', lang)
    .set('page', current_page)
    .set('page_size', page_size)
    .set('user_id', user_id)
    .set('text_id', text);

    const headers = new HttpHeaders({
      'accept': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.get(url, { headers, params });
  }


  //this is the api to get the list of STT text
  getSTTTextList(language: string, page: number, page_size: number,searchQuery:string): Observable<any> {
    const clientid = localStorage.getItem('userId') || ''; // Ensure user_id is not null
    const encodedSearchQuery = encodeURIComponent(searchQuery || '');
    let url = environment.url + `stt/?language=${language}&clientid=${clientid}&page=${page}&page_size=${page_size}`;
    if (searchQuery) {
      url += `&text=${encodedSearchQuery}`;
    }
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.get(url, { headers });
  }

  //this is the api to get the STT inferenced(transcribed) text
  inferenceSttText(audioBlob: Blob,idOfTextFromServer:string,text:string,text_id:string): Observable<any> {
    // const url = 'https://datacreationtool.procit.com/nodeapi/stt_voice';
    let url = environment.url + "stt_voice";

    // Query parameters
    const userId = localStorage.getItem('userId') || ''; // Ensure userId is not null
    const lang  = localStorage.getItem('langCategory') || 'nl'; // Default to 'nl' if not set
    const user = localStorage.getItem('userName') || 'admin'; // Default to 'rikesh' if not set
    const authKey = 'c14475f1-4968-4418-bb23-f242cf8070c5';
    const params = new HttpParams()
      .set('lang', lang)
      .set('userid', userId)
      .set('user', user)
      .set('text', text)
      .set('text_id', text_id) // Add text_id to the query parameters;

    // FormData with file
    const formData = new FormData();
    formData.append('file', audioBlob, 'apple.mp3'); // Field name must match API ("file")

    // const headers = new HttpHeaders({ 'Accept': 'application/json' });
    // const headers = new HttpHeaders({
    //   'Accept': 'application/json',
    //   'x-security-authkey': authKey
    // });
    const headers = new HttpHeaders().set('x-security-authkey', authKey);
    

    return this.http.post(url, formData, { headers, params });
  }

  //this is the api to save the STT inference result
  sttInferenceResult(guid: string, remarks: string): Observable<any> {
    let url = environment.url + `stt_update_remarks/${guid}`;
    
    const params = new HttpParams().set('remarks', remarks);
    
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'X-Security-AuthKey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.put(url, null, { headers, params });
  }


  //this is the api to list only STT users who has inferenced the data
  // getSTTUsers(): Observable<any> {
  //   let url = environment.url + "list_stt_users";


  //   const headers = new HttpHeaders({
  //     'accept': 'application/json',
  //     'X-Security-AuthKey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
  //   });

  //   return this.http.get(url, { headers });
  // }


  getSTTUsers(): Observable<any>{
    // const clientId = localStorage.getItem('userId');
    let url = environment.url + "list_stt_users";
    const headers = new HttpHeaders().set('X-Security-AuthKey', 'c14475f1-4968-4418-bb23-f242cf8070c5');
    return this.http.get(url, { headers: headers }).pipe(
      // Handle errors
      catchError((error: HttpErrorResponse) => {
        console.error('Error occurred:', error.message);
        // Return a fallback value or an empty observable
        return of(null);
      })
    );
  }
  addSTTText(text: string, language: string, user: string, userId: string): Observable<any> {
    // const url = 'https://datacreationtool.procit.com/nodeapi/add_stt_text';
    let url = environment.url + "add_stt_text";


    const body = {
      text: text,
      language: language,
      user: user,
      userid: userId
    };

    const headers = new HttpHeaders({
      'accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Security-AuthKey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.post(url, body, { headers });
  }

  deleteSTTText(textId: string): Observable<any> {
    const url = environment.url + "delete_stt_text/" + textId;
    // console.log("Text ID to delete is:", textId);
    // const authenticationKey: any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders({
      'X-Security-Authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5',
      'Content-Type': 'application/json'
    });
    return this.http.delete(url, { headers: headers });
  }

  deleteSTTInferencedData(textId: string): Observable<any> {
    const url = environment.url + "delete_sound_inference/" + textId;
    // console.log("Text ID to delete is:", textId);
    // const authenticationKey: any = localStorage.getItem('authenticationKey');
    const headers = new HttpHeaders({
      'X-Security-Authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5',
      'Content-Type': 'application/json'
    });
    return this.http.delete(url, { headers: headers });
  }



  //API for classification analysis model inferencing
  getClassificationQuestionList(language: string, page: number, page_size: number,searchQuery:string): Observable<any> {
    const user_id = localStorage.getItem('userId') || ''; // Ensure user_id is not null
    const encodedSearchQuery = encodeURIComponent(searchQuery || '');
    let url = environment.url + `fetch_questions/?lang=${language}&page=${page}&page_size=${page_size}&user_id=${user_id}`;
    if (searchQuery) {
      url += `&search=${encodedSearchQuery}`;
    }
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.get(url, { headers });
  }

  getClassificationInferenceResult(question: string,answer: string,language: string): Observable<any> {
    // Construct HttpParams for the query parameters
    // question = '83377c94-82d6-485d-8671-21471f861556';
    let params = new HttpParams()
      .set('questionid', question)
      .set('answer', answer)
      .set('lang', language);

    // Define the headers
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    const url = environment.url + 'classify_text';

    // Make the POST request. The body is null as parameters are in the URL.
    return this.http.post(url, null, { headers, params });
  }

  addClassificationInferenceData(question_guid: string,question:string, answer: string, language: string, classification: string, confidence_score: number,correct_answer:string): Observable<any> {
    const url = environment.url + 'post_classification_data';
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5',
      'Content-Type': 'application/json'
    });

    const user_id = localStorage.getItem('userId') || '';

    const payload = {
        questionid: question_guid,
        question: question,
        user_answer: answer,
        predicted_answer: classification,
        corrected_answer: correct_answer,
        confidence_score: confidence_score,
        language: language,
        user_id: user_id,
        model_name: "classification_v1"
      };

    return this.http.post(url, payload, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error occurred:', error.message);
        return of(null); // fallback value
      })
    );

  }


  getClassificationInferenceSavedData(
    language: string,
    page: string,
    page_size: string,
    currentTextIdForHistory: string,
    currentUserIdForHistory: string,
    showDataOf: string
  ): Observable<any> {
    

    let url = environment.url + `classification_history?page=${page}&page_size=${page_size}&text_guid=${currentTextIdForHistory}`;



    const user_id: string = (showDataOf === 'current_user') ? currentUserIdForHistory : '';
    
    if(user_id !== ''){
      url = url  + `&user_id=${user_id}`;  
    }else{
      url = url;
    }
    
    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'auth_key': 'jipFLutdqFIkNpKIupi5H9tAn9h2XI2OMAddFiPNR4E'
    // });

    const headers = new HttpHeaders({
      'accept': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.get(url, { headers });
  }

  getClassificationInferenceSavedDataAll(
    language: string,
    page: string,
    page_size: string,
    searchQuery: string,
    text_guid: string,
    user_id: string
  ): Observable<any> {
    const encodedSearchQuery = encodeURIComponent(searchQuery || '');
    
    let url = environment.url + `classification_history?page=${page}&page_size=${page_size}`;
    if(user_id !== 'all_user'){
      url = url  + `&user_id=${user_id}`;  
    }else{
      url = url;
    }
    
    if (searchQuery) {
      url += `&search=${encodedSearchQuery}`;
    }

    if (text_guid !== '1') {
      url += `&text_guid=${text_guid}`;
    }

    if (user_id !== 'all_user') {
      url += `&user_id=${user_id}`;
    }

    const headers = new HttpHeaders({
      'accept': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.get(url, { headers });
  }

  deleteClassificationInferencedData(guid: string): Observable<any> {
    const url = environment.url + `delete_classification_data/${guid}`;
    
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'x-security-authkey': 'c14475f1-4968-4418-bb23-f242cf8070c5',
      'Content-Type': 'application/json'
    });

    return this.http.delete(url, { headers });
  }

  getClassificationUsers(): Observable<any> {
    const url = environment.url + 'classification_users';
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Security-AuthKey': 'c14475f1-4968-4418-bb23-f242cf8070c5'
    });

    return this.http.get(url, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error occurred:', error.message);
        return of(null);
      })
    );
  }




  



}
